import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function ShippingReturnComponent() {

    return (
        <article className='sectionOrArticleTB'>
            <div className='text-center'>
                <h1 className='caregoriesTitle'>Shipping & Return Policy</h1>
            </div>
            <article className='sectionOrArticleB'>
                <div className='imgStripContainer'>
                    <div className='imgStripText'>
                        <Image src='/images/Strip5.gif'
                            alt="Strip"
                            fill
                            sizes="(max-width: 768px) 100vw,
                    (max-width: 1200px) 50vw,
                    33vw"
                        />
                    </div>
                </div>

            </article>
            <article className='sectionOrArticleT mt-5 mt-lg-0 mt-xl-0 mt-xxl-0'>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={11} md={10} lg={9} xl={8}>
                            <p>Shipping and insurance are FREE. You can buy with confidence as you have 14 day unconditional return privilege.</p>
                        </Col>
                    </Row>
                </Container>
            </article>
        </article>
    )
}